var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-modal-w"},[_c('b-modal',{staticClass:"max-modal-w",attrs:{"id":_vm.id,"size":"lh","hide-header":"","hide-footer":"","dialog-class":"getintouch-modal-dialog modal-dialog-centered"}},[_c('get-in-touch',{attrs:{"heroPhone":_vm.heroPhone}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }